import { useState } from "react";
import { motion } from "framer-motion";
import ReCAPTCHA from 'react-google-recaptcha';
import roofingIcon from '../../../assets/images/icons/roofing.svg';
import projectIcon from '../../../assets/images/icons/project.svg';
import contactIcon from '../../../assets/images/icons/contact.svg';

const Field = ({ label, value }) => (
  <div className="mt-2">
    <dt className="inline text-sm font-bold text-black-900">{label}</dt>
    <dd className="inline lg:block ml-2 text-sm text-gray-900">{value}</dd>
  </div>
);

const Card = ({ children, classNames }) => (
  <div
    className={
      'border-4 border-green-900 opacity-100 p-4 rounded-md shadow-2xl overflow-y-auto w-full lg:w-1/3 bg-semiWhite ' +
      classNames
    }
  >
    {children}
  </div>
);

const CardHeader = ({ icon, label }) => (
  <div className="flex items-center justify-center lg:justify-start">
    <dt className="inline text-sm ">{icon}</dt>
    <dd className="inline ml-2 text-lg font-bold text-black-900 font-serif">
      {label}
    </dd>
  </div>
);

const NewProjectReviewStep = ({ data, propertyData, onPrev, onNext }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const getAnswer = (index) => {
    const answer = data.answers[`q${index + 1}`];
    return Array.isArray(answer) ? answer.join(', ') : answer;
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        default: { duration: 0.6 },
        ease: "easeInOut",
      }}
      className={`mx-auto md:px-8 md:pt-10 bg-no-repeat	bg-cover	bg-center md:pb-10
                  bg-review_step min-h-900 `}
    >
      <div className="flex justify-center max-w-7xl m-auto">
        <div className=" lg:m-auto justify-center w-full	">
          <div
            className="h-full bg-semiWhite opacity-90 p-10 md:p-7    
            flex justify-center flex-col md:rounded-t-lg 
            md:rounded-card shadow-2xl "
          >
            <div className={`max-w-full`}>
              <h2 className="text-center pb-2">Review</h2>
              <div className="flex justify-center lg:space-x-6  mb-4 lg:max-h-80 flex-col lg:flex-row space-y-6	lg:space-y-0 ">
                <Card>
                  <CardHeader
                    icon={<img src={projectIcon} alt="bla" />}
                    label=" Project"
                  />
                  <dl>
                    <Field label="Title:" value={data.title} />
                    <Field label="Label:" value={propertyData.label} />
                    <Field
                      label="Location:"
                      value={propertyData.addressTitle}
                    />
                    {data.description && (
                      <Field label="Description:" value={data.description} />
                    )}
                    {data.startDate && (
                      <Field label="Start date:" value={data.startDate} />
                    )}
                    {data.endDate && (
                      <Field label="Completion date:" value={data.endDate} />
                    )}
                  </dl>
                </Card>
                <Card>
                  <CardHeader
                    icon={<img src={roofingIcon} alt="bla" />}
                    label=" Service"
                  />
                  <dl className="mb-8">
                    <Field label="Name:" value={data.service.name} />
                    {data.service.questions.map((question, index) => (
                      <Field
                        key={question.id}
                        label={question?.content ? question?.content : "Press back to to rechose service"}
                        value={getAnswer(index)}
                      />
                    ))}
                  </dl>
                </Card>
                <Card>
                  <CardHeader
                    icon={<img src={contactIcon} alt="bla" />}
                    label=" Contact"
                  />
                  <dl>
                    <Field
                      label="Name:"
                      value={`${data.first_name} ${data.last_name}`}
                    />
                    <Field label="Email:" value={data.email} />
                    <Field label="Phone:" value={"+" + data.phone} />
                  </dl>
                </Card>
              </div>
              <div className="flex justify-center space-x-6  mb-4">
                <ReCAPTCHA
                  sitekey="6Ld3ir8cAAAAAHRbEDfJmP99t1McCqoY7SZfC-gV"
                  onChange={(value) => setIsDisabled(!value)}
                />
              </div>
              <div className="flex justify-center items-center pt-8 max-w-md m-auto">
                <button
                  className="btn-outline mr-1"
                  type="button"
                  onClick={onPrev}
                >
                  Back
                </button>
                <button
                  disabled={isDisabled}
                  className="btn-primary ml-1"
                  type="button"
                  onClick={onNext}
                >
                  Create Project
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default NewProjectReviewStep;
